import React from 'react'
import styled from 'styled-components';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GithubIcon from '@material-ui/icons/GitHub';
import InstagramIcon from '@material-ui/icons/Instagram';
import TwitterIcon from '@material-ui/icons/Twitter';
import YoutubeIcon from '@material-ui/icons/YouTube';
import Particle from '../Components/Particle';
import ServicesSection from '../Components/ServicesSection';
import Update from '../Components/Update';

function HomePage() {
    return (
        <HomePageStyled>
            <div className="particle-con">
                <Particle />
            </div>
            
            
           
              
           
            <div className="typography">
                <h1>HELLO!  <span>I'm Prabhu</span></h1>
                <p>
                I find myself having a million thoughts every day. 
                Some of these thoughts have led to full-length discussions with my friends, 
                discoveries about myself and the world around me, and ideas about the best ways to go about life.
                    
                </p>
                <p>
                <span>
                I welcome you to share your thoughts with me, as well. Let the overthinking begin!
                </span>
                </p>
                
                <div className="icons">
                    <a href="https://www.linkedin.com/in/prabhu-kumar-saw-43b467135/" className="icon i-linkedin">
                        <LinkedInIcon />
                    </a>
                    <a href="https://github.com/prabhukumarsaw" className="icon i-github">
                        <GithubIcon />
                    </a>
                    <a href="https://www.instagram.com/iamsawraj/?hl=en" className="icon i-instagram"> 
                        <InstagramIcon />
                    </a>
                    <a href="https://www.instagram.com/iamsawraj/?hl=en" className="icon i-twitter"> 
                        <TwitterIcon />
                    </a>
                    <a href="https://www.instagram.com/iamsawraj/?hl=en" className="icon i-youtube"> 
                        <YoutubeIcon />
                    </a>
                </div>
                
                              
            </div>
           <div className="service-1">

            <ServicesSection />
            </div> 
            <div className="service-1">

            <Update/>
            </div>


            

            
        </HomePageStyled>
       
        
    )
}

const HomePageStyled = styled.header`
    width: 100%;
    height: 100vh;
    position: relative;
   
    .service-1{
        margin: 25px;
        text-align: center;
        display: flex;
            justify-content: center;
    }

    .typography{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        width: 80%;

        .icons{
            display: flex;
            justify-content: center;
            margin-top: 1rem;
            .icon{
                border: 2px solid var(--border-color);
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                transition: all .4s ease-in-out;
                cursor: pointer;
                &:hover{
                    border: 2px solid var(--primary-color);
                    color: var(--primary-color);
                }
                &:not(:last-child){
                    margin-right: 1rem;
                }
                svg{
                    margin: .5rem;
                }
            }

            .i-youtube{
                &:hover{
                    border: 2px solid red;
                    color: red;
                }
            }
            .i-github{
                &:hover{
                    border: 2px solid #5F4687;
                    color: #5F4687;
                }
            }
        }
    }
`;

export default HomePage;
